import { Button, ButtonProps, Typography } from 'components/common'
import { useBreakpoint } from 'hooks/useBreakpoint'
import Link from 'next/link'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface IProps {
  title?: string
  titleButtonProps?: ButtonProps
  padded?: boolean
  renderSearch?: React.ReactChild
  children?: React.ReactChild
}

function WhiteBox({
  title,
  titleButtonProps,
  padded = true,
  renderSearch,
  children
}: IProps) {
  const showHeader = !!title || !!titleButtonProps
  const { isSm } = useBreakpoint()

  return (
    <div className="bg-white rounded-lg shadow">
      {showHeader && (
        <div className="border-b border-solid border-b-gray-200 py-4 px-5 justify-between flex flex-col max-xs:flex-row  max-xs:items-stretch">
          {showHeader && (
            <div className="justify-between flex text-left">
              <Typography size="xl" fontWeight="bold" className="text-left">
                {title}
              </Typography>
              {isSm && titleButtonProps && (
                <Link href={titleButtonProps.href!} passHref>
                  <Button {...titleButtonProps} size="lg" />
                </Link>
              )}
            </div>
          )}

          <div className="flex flex-1 justify-end gap-16">
            {renderSearch}

            {!isSm && titleButtonProps && (
              <Link href={titleButtonProps.href!} passHref>
                <Button {...titleButtonProps} fullWidth size="lg" />
              </Link>
            )}
          </div>
        </div>
      )}

      <div
        className={twMerge(
          'pb-5',
          padded && 'px-2',
          showHeader ? 'pt-2' : 'pt-4'
        )}
      >
        {children}
      </div>
    </div>
  )
}

export default WhiteBox
